module.exports = __webpack_public_path__ + "static/media/ghaisani_khoirunnisa.c257ded9.jpg";